import { CountryCode } from "../types/common";

export const minFinancingAmountPerCountry: Record<
  CountryCode,
  { numericValue: number; stringValue: string }
> = {
  [CountryCode.FI]: { numericValue: 1000, stringValue: "1000 €" },
  [CountryCode.SE]: { numericValue: 10000, stringValue: "10 000 kr" },
};
